export const LotSizingType = {
  PO: 'PO',
  TRANSIT: 'TRANSIT',
} as const;

export type LotSizingType = (typeof LotSizingType)[keyof typeof LotSizingType];
